import React, { useState, useEffect, useRef } from 'react'
import { withOidcSecure } from '@axa-fr/react-oidc'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import HomeLayout from '../../../Layout/HomeLayout';
import LeftBar from '../../../CustomComponents/DynamicComponent/LeftBar';
import DynamicCard from '../../../CustomComponents/DynamicCard';
import FindATM from '../../../../assets/images/illo-ATM.png'
import { useNavigate } from 'react-router';
import Accordion from '../../../CustomComponents/Accordation';
import { GetApiHeadersWithBearer, GetRequest } from '../../../../network/NetworkUtils';
import { STATUS_SUCCESS_CODE } from '../../../../network/URLConstants';
import { getCategories, getfaqsdata } from '../../../../utils';
import { KudzuHelpSidebar } from '../../../../utils';
import { height, width } from "../../../CustomComponents/DynamicCard/DynamicCardStyles";
import FooterContent from '../../../CustomComponents/Footer';
import Loader from '../../../CustomComponents/Loader';
import CustomAlertModel from '../../../CustomComponents/CustomAlertModel';
import logFirebaseEvents from '../../../LogFirebaseEvents';
import { appTheme } from '../../../../helpers/utils/Utils';
import CardHeading from '../../../CustomComponents/CardHeading';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';
 
const KudzuHelpAndFAQ = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [faqs, setFaqs] = useState({});
    const [expandedIndex, setExpandedIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
 
    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro text-[var(--modal-text-highlight)] modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title text-[var(--modal-text-heading-clr)] lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[14px] md:text-[13px] sm:text-[11px] text-[12px] font-normal cursor-pointer pointer-events-none";
    const [modelImage, setModelImage] = useState('')
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [type, setType] = useState('')
    const [footerMsg, setFooterMsg] = useState('');
    const [toNavigate, setToNavigate] = useState('');
    // const [isLoading, setIsLoading] = useState(false);
 
    const cards = useSelector(state => JSON.parse(state.userCards));
    const initialCards = useRef(cards); // Store initial cards
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    useDocumentTitle(t('page_title_kudzu_faq'));

    useEffect(() => {
        if (initialCards?.current?.length > 0) {
            setIsLoading(true)
            const freshDeskDomain = initialCards.current.find(card => card.AccountTypeBit63 === 64)?.FreshDeskDomain;
            const freshDeskCategoryID = initialCards.current.find(card => card.AccountTypeBit63 === 64)?.FreshDeskCategoryID;
            const freshDeskAPIKey = initialCards.current.find(card => card.AccountTypeBit63 === 64)?.FreshDeskAPIKey;
 
            getCategories(freshDeskDomain, freshDeskCategoryID, freshDeskAPIKey)
                .then(response => {
                    // debugger;
                    setCategories(response);
                    setExpandedIndex(0);
                    loadFaqs(response[0].id, freshDeskDomain, freshDeskAPIKey);
                })
                .catch(error => {
                    console.error("Error fetching categories:", error);
                });
        }
    }, []);
 
    const handleAccordionClick = (index, categoryId) => {
        setExpandedIndex(index);
        if (categoryId) {
            loadFaqs(categoryId, cards?.find(card => card.AccountTypeBit63 === 64)?.FreshDeskDomain, cards?.find(card => card.AccountTypeBit63 === 64)?.FreshDeskAPIKey);
        }
    };
 
    const loadFaqs = (categoryId, domain, apiKey) => {
 
        if (!faqs[categoryId]) {
            getfaqsdata(domain, categoryId, apiKey, "100")
                .then(response => {
                    setFaqs(prevFaqs => ({
                        ...prevFaqs,
                        [categoryId]: response,
                    }));
                    setIsLoading(false)
 
                })
                .catch(error => {
                });
        }
    };
 
 
    const Headingcom = () => {
        return (
            <>
                <div className="relative">
                    <div className="flex flex-row justify-between m-10">
                        <div className="flex flex-row gap-2 ">
                            <p className='font-hanken-grotesk text-[var(--text-clr-transactions)] font-[600] text-[15px] leading-[23px] lg:font-[500] lg:text-[26px] lg:leading-[36px]'>{t("helpfaq")}</p>
                        </div>
                    </div>
                </div>
                <div className='border-t-[2.5px] border-[#A3CEBB] sm:mx-0 mx-4'>
 
                </div>
            </>
 
        )
    }
    const helpListItems = 'font-hanken-grotesk font-[600] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] leading-[20px] md:font-[700] md:leading-[16px] lg:leading-[16px] text-[#FEFAEE]'
 
 
    const helpFaqChildren1 = () => {
        return (
            <>
                <div className="w-full flex flex-row mb-10 lg:mb-32">
                    <div className='flex flex-col w-full sm:px-0 px-4'>
 
                        <div>
                            {categories.map((category, index) => (
                                <Accordion
                                    key={category.id}
                                    title={category.name}
                                    content={faqs[category.id] || []}
                                    index={index}
                                    categoryId={category.id}
                                    linkClickAction={linkClickAction}
                                    onClick={() => handleAccordionClick(index, category.id)}
                                    isKudzu = {true}
                                />
                            ))}
                        </div>
                    </div>
                </div>
 
            </>
        )
    }
 
 
    const footerContent = () => {
        return (
            <FooterContent highlightText={t("findNoFeeATM")}
                subHeaderText={t("findATMSubHeading")}
                image={appThemeData.findATMIcon}
                buttonEnabled={true}
                buttonText={t("findATMBtn")}
                footerBtnAction={() => {navigate('/Help/Kudzu/FindATM');logFirebaseEvents("Help", "Find_ATM_Clicked", "Find_ATM_Clicked","", "");}}
                type={"FindATM"}
                highlightTextColor={"#2965FB"}
                isSubheadingwidth={false} />
        )
    }
 
    const linkClickAction = (link) => {
       debugger
        if (link.link) {
 
            if (link.link.includes('kudzumoney')) {
                window.open(link.link, '_blank');
            }
            else {
                setToNavigate(link.link)
                showAlertModal(true, t("heads_up"), t("about_to_leave_kudzu"), t("redirected_from_kudzu"), true, true, 'Continue', 'Cancel', true, '')
            }
        }
 
    }
 
 
    //////
    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage) => {
 
        setShowModel(showModel)
 
        setHighlightMsg(highlightMsg)
 
        setheaderMsg(headerMsg)
 
        setSubHeaderMsg(subHeaderMsg)
 
        setBtn1Exists(btn1Exists)
 
        setBtn2Exists(btn2Exists)
 
        setBtn1Text(btn1Text)
 
        setBtn2Text(btn2Text)
 
        setBtn1TypeAcpt(btn1TypeAcpt)
 
        setModelImage(modelImage)
 
    }
 
    const closeCustomAlertModal = () => {
 
        setShowModel(false);
 
    }
 
    const onAcptBtnClick = async () => {
 
        if (headerMsg == t('about_to_leave_kudzu')) { window.open(toNavigate, '_blank'); closeCustomAlertModal(); setToNavigate('') }
 
    }
 
    const onCancelBtnClick = () => {
 
        if (headerMsg == t('about_to_leave_kudzu')) { closeCustomAlertModal(); setToNavigate('') }
 
    }
 
    return (
        <>
            <HomeLayout>
                <KudzuHelpSidebar HelpselectedIndex={1} isSubMenu={true} />
                <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>
                <div className='flex flex-col md:w-[860px] sm:w-[464px]
            w-[100%] animate__animated animate__fadeInRight '>
                    <DynamicCard
                        footer={true}
                        header={false}
                        CardRadius={true}
                        cardWidth={width.homeCard}
                       // footer={true}
                        HeaderRadius={true}
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        backgroundColor={'--cardHeading-bg'}
                        HeaderContent={
                            <>
                                <CardHeading heading={t('Kudzu_FAQ')} />
                            </>
                        }
                        >
                        {/* <div class="lg:my-[2rem] text-[var(--text-clr-transactions)] md:my-[1.5rem] my-[1.5rem] font-[500] md:font-[500]
                       lg:text-[26px] md:text-[22px]
                       sm:text-[15px] sm:font-[600] text-[20px] leading-[36px] font-hanken-grotesk
                        sm:mx-0 mx-4">{t("helpfaq")}</div> */}
                      <div className={`${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}
                        sm:mx-0 mx-4 mb-6`}></div>
                        {helpFaqChildren1()}
                    </DynamicCard>
                    {footerContent()}
 
                </div>
 
 
                {/* <div className='flex flex-col justify-center animate__animated animate__fadeInRight animate__slow'>
 
                <DynamicCard
                    isCardHeader={true}
                    cardHeight='content-fit'
                    cardContent={helpFaqChildren1()}
                    isCardFooter={false}
                    headerContent={Headingcom()}
                    headerBg={'#ffffff'}
 
                />
                <DynamicCard
                    isCardHeader={false}
                    cardHeight='content-fit'
                    cardContent={helpFaqChildren2()}
                    isCardFooter={false}
                    cardCornerType='tl-br'
                    cardBackGround="bg-[#E0E9EE]"
                />
 
            </div> */}
                {/* {isLoading && <Loader />} */}
 
            </HomeLayout >
            <CustomAlertModel isOpen={showModel}
                onClose={closeCustomAlertModal}
                image={modelImage}
                highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
                HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
            />
 
            {isLoading && <Loader />}
        </>
 
 
    )
}
 
export default withOidcSecure(KudzuHelpAndFAQ)